import { alpha } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const DATA_SECTION = {
  anyword: 'anyword',
  other: 'other',
};

const DATA_SECTION_PROPS = {
  [DATA_SECTION.anyword]: {
    pointFillColor: alpha(COLORS.primary.default, 0.3),
    pointStrokeColor: COLORS.primary.active,
  },
  [DATA_SECTION.other]: {
    pointFillColor: alpha('#CC79A7', 0.3),
    pointStrokeColor: '#CC79A7',
  },
};

export const getDataSectionPointFillColor = (section) => DATA_SECTION_PROPS[section].pointFillColor;
export const getDataSectionPointStrokeColor = (section) =>
  DATA_SECTION_PROPS[section].pointStrokeColor;
